<template>
  <div id="container">
      <Spinner :show="loading"></Spinner>
      <Header></Header>
      <Modal v-if="modal.title" :title="modal.title" :body="modal.body" :centerBody="modal.centerBody" :className="modal.className" :buttons="modal.buttons"></Modal>
      <!-- <AddressBook ref="addressBook"></AddressBook> -->
      <WalletTabs></WalletTabs>
      <section ref="content" id="content" class="section subnav no-vpadding">
          <Notification v-if="notification.show" :text="notification.text" :className="notification.className"></Notification>
          <QrScanner ref="qrScanner" :className.sync="qrScanner.className"></QrScanner>
          <!-- <h4 class="is-size-4 has-text-centered">{{ $t("SendingCredit") }}</h4> -->
          <div class="relative has-text-centered">
            <div ref="step1" class="absolute full-width">
                <!-- <label class="label" v-html="$t('WalletTransferBody', {qrIcon: `<i class='fa fa-qrcode'></i>`})"></label> -->
                <div class="columns is-mobile is-centered">
                    <div class="column is-half">
                        <div class="control has-icons-left">
                            <div class="select is-fullwidth">
                                <select ref="callingCode" v-model="callingCode" required>
                                    <option disabled value="disabled">{{ $t("Country")}}</option>
                                    <option v-for="country in countries" :key="country.id" :value="country.callingCode">{{ country.name }} (+{{ country.callingCode }})</option>
                                </select>
                            </div>
                            <div class="icon is-small is-left">
                                <i class="fa fa-globe"></i>
                            </div>
                        </div>
                    </div>
                    <div class="column is-half">
                        <div class="field">
                            <div class="control has-icons-left has-icons-right">
                                <input ref="mobile" @click="hideTabs()" @focus="hideTabs()" @blur="showTabs()" v-model="mobile" class="input no-spinner" type="number" :placeholder="$t('Mobile')" required min="0">
                                <span class="icon is-small is-left double">
                                    <i class="fa fa-phone"></i>
                                    <!-- <i @click="showContacts()" class="fa fa-address-book clickable"></i> -->
                                </span>
                                <span @click="scanQr()" :title="$t('ClickToScanQrCode')" class="icon clickable is-small is-right">
                                    <i class="fa fa-qrcode"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="columns is-mobile is-centered">
                    <div class="column is-half has-text-centered">
                        <a @click="next()" class="button is-primary is-fullwidth">
                            <span class="icon">
                                <i class="fa" :class="[loading ? 'fa-spinner fa-spin' : 'fa-arrow-right']"></i>
                            </span>
                            <span>{{ $t("Next") }}</span>
                        </a>
                    </div>
                    <div class="column is-half has-text-centered">
                        <a @click="$router.go(-1)" class="button is-info is-fullwidth">
                            <span class="icon">
                                <i class="fa fa-times"></i>
                            </span>
                            <span>{{ $t("Cancel") }}</span>
                        </a>
                    </div>
                </div>
                <div class="columns is-mobile is-centered">
                    <div class="column is-full has-text-centered">
                        <a @click="$router.push('/tag/topup')" class="button is-primary is-fullwidth">
                            <span class="icon">
                                <i class="fa fa-tag"></i>
                            </span>
                            <span>{{ $t("SendToTag") }}</span>
                        </a>
                    </div>
                </div>
                <div class="columns is-mobile is-centered">
                    <div class="column is-full has-text-centered">
                        <a @click="$router.push('/meter/topup')" class="button is-info is-fullwidth">
                            <span class="icon">
                                <i class="fa fa-home"></i>
                            </span>
                            <span>Send to household meter</span>
                        </a>
                    </div>
                </div>
            </div>
            <div ref="step2" class="absolute full-width is-hidden">
                <div class="columns is-mobile is-centered">
                    <div class="column is-full has-text-centered">
                        <div class="field">
                            <label class="label">{{ $t("SendTo") }} </label>
                            <div class="control has-icons-left">
                                <input class="input" v-model="recipient" type="text" disabled readonly>
                                <span class="icon is-small is-left">
                                    <i class="fa fa-tag"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="columns is-mobile is-centered">
                    <div class="column is-full has-text-centered">
                        <div class="field">
                            <label class="label">{{ $t("Amount") }}</label>
                            <div class="control has-icons-left">
                                <input ref="amount" @click="hideTabs()" @focus="hideTabs()" @blur="showTabs()" class="input" type="number" :placeholder="$t('Amount')" required :step="minTransfer" v-model.number="amount" :min="minTransfer">
                                <span v-html="user.wallet.currency.symbol" class="icon is-small is-left"></span>
                            </div>
                        </div>
                        <div>{{ $t("MinimumTransferBody", [this.formatCurrency(this.minimumTransfer(user.wallet.currency), user.wallet.currency)]) }}</div>
                    </div>
                </div>
                <div class="columns is-mobile is-centered">
                    <div class="column is-half has-text-centered">
                        <a @click="send()" class="button is-primary is-fullwidth">
                            <span class="icon">
                                <i class="fa fa-exchange"></i>
                            </span>
                            <span>{{ $t("Send") }}</span>
                        </a>
                    </div>
                    <div class="column is-half has-text-centered">
                        <a @click="back()" class="button is-info is-fullwidth">
                            <span class="icon">
                                <i class="fa fa-arrow-left"></i>
                            </span>
                            <span>{{ $t("Back") }}</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
      </section>
  <NavigationTabs></NavigationTabs>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import Modal from "@/components/Modal.vue";
// import AddressBook from "@/components/AddressBook.vue";
import WalletTabs from "@/components/WalletTabs.vue";
import Notification from "@/components/Notification.vue";
import QrScanner from "@/components/QrScanner.vue";
import NavigationTabs from "@/components/NavigationTabs.vue";
import Spinner from "@/components/Spinner.vue";

export default {
  name: "WalletSend",
  components: {
    Header,
    Modal,
    // AddressBook,
    WalletTabs,
    Notification,
    QrScanner,
    NavigationTabs,
    Spinner
  },
  props:
  {
    _callingCode:
    {
        type: String,
        default: "disabled"
    },
    _mobile: String,
    _amount: String,
    _currency: String
  },
  async mounted() {
    this.minTransfer = this.minimumTransfer(this.user.wallet.currency);
    this.amount = this.minimumTransfer(this.user.wallet.currency);

    if(this._amount && this._currency)
    {
        const response = await this.$http.get(`/Utilities/LocalCurrency?amount=${this._amount}&currencyCode=${this._currency}`);
        this.amount = response.data.amount;
    }

    if(this._callingCode && this._mobile)
    {
        this.callingCode = this._callingCode;
        this.mobile = this._mobile;
        this.next();
    }

    await this.updateUser();
  },
  data () {
      return {
          callingCode: this._callingCode,
          name: null,
          mobile: this._mobile,
          walletID: null,
          minTransfer: 0,
          amount: 0,
          modal: {
              title: null,
              body: null,
              centerBody: true,
              className: "",
              buttons:
              [
                {id: 0, title: this.$t("Yes"), className: "is-primary", click: this.doSend},
                {id: 1, title: this.$t("No"), className: "is-info", click: () => { this.modal.className = ""; }}
              ]
          },
          qrScanner: {
              className: ""
          },
          step: 1
      }
  },
  computed:
  {
    recipient: function()
    {
        return `${this.name} (+${this.callingCode}${this.mobile})`;
    }
  },
  methods:
  {
      back: function() {
        this.$refs[`step${this.step}`].classList.remove("is-hidden");
        this.$refs[`step${this.step+1}`].classList.add("is-hidden");
      },
      next: async function() {
        if (this.$refs.callingCode.selectedIndex == 0) {
            this.$refs.callingCode.selectedIndex = -1;
        }

        if(!this.$refs.callingCode.checkValidity())
        {
            this.$refs.callingCode.reportValidity();
            return;
        }
        if(!this.$refs.mobile.checkValidity())
        {
            this.$refs.mobile.reportValidity();
            return;
        }

        try
        {
            const response = await this.$http.get(`/User?callingCode=${this.callingCode}&mobile=${this.mobile}`);
            const recipientMobile = response.data.callingCode + response.data.mobile;
            const userMobile = this.user.callingCode + this.user.mobile;

            if(userMobile == recipientMobile)
            {
                throw new Error(this.$t("ErrorCantSendToYourself"));
            }

            this.name = response.data.name;
            this.walletID = response.data.walletID;
            this.$refs[`step${this.step}`].classList.add("is-hidden");
            this.$refs[`step${this.step+1}`].classList.remove("is-hidden");
        }

        catch(error)
        {
            this.$refs.content.scrollTo(0, 0);

            if(error.response)
            {
                this.notification =
                {
                    show: true,
                    className: "is-danger",
                    text: error.response.data.message
                }
            }
            
            else
            {
                this.notification =
                {
                    show: true,
                    className: "is-danger",
                    text: error.message
                }
            }
        }
      },
      scanQr: function() {
          this.$refs.qrScanner.scanQr();
      },
      qrResult: function(result) {
        const pattern = /^(\d+)\.(\d+)$/;
        const matches = result.match(pattern);

        if (!matches || matches.length != 3)
        {
            alert(this.$t("ErrorQrCodeDoesntContainAMobile"));
            return;
        }

        this.callingCode = matches[1];
        this.mobile = matches[2];
      },
      send: function() {
        const amount = parseFloat(this.amount);

        if (isNaN(amount) || amount < parseFloat(this.minTransfer)) {
            this.$refs.amount.reportValidity();
            return;
        }

        this.modal.title = this.$t("ConfirmTransfer");
        this.modal.body = `<p>${this.$t("ConfirmTransferBody", {amount: this.formatCurrency(this.amount, this.user.wallet.currency), recipient: this.recipient}).split("\\n")}</p>`;
        this.modal.className = "is-active";
      },
      doSend: async function()
      {
        if(this.loading)
        {
            return;
        }

        try
        {
            this.$http.put(`/Transactions`, // WebApiV2.Controllers.TransactionsController.New
            [
                {
                    recipientWalletID: this.walletID,
                    currencyCode: this.user.wallet.currency.code,
                    amount: this.amount
                }
            ]).then(async (response) => {
                  console.dir(response);
                  let s = 0 | response.status;
                  if (s < 100 || s > 599 || (s > 299 && s < 400)) {// unexpected ---------------------------------------
                    this.$refs.content.scrollTo(0, 0);
                    this.modal.className = "";
                    this.notification = {
                      show: true, className: "is-danger",
                      text: 'Onyesha hii kwa mhandisi. Show this to support: "WebApiV2.Controllers.TransactionsController.New Unexpected result code: ' + s + '"'
                    }
                  } else if (s <= 299) {   // success ------------------------------------------------------------------
                    this.modal.className = "is-active";
                    this.modal.title = this.$t("CreditSent");
                    this.modal.body = this.$t("CreditSentBody", [this.formatCurrency(this.amount, this.user.wallet.currency), this.recipient]).split("\\n").join("<br><br>");
                    this.modal.buttons =
                        [
                          {
                            id: 0, title: this.$t("Yes"), className: "is-primary", click: function () {
                              this.$router.go()
                            }.bind(this)
                          },
                          {
                            id: 1, title: this.$t("No"), className: "is-info", click: function () {
                              this.$router.push("/wallet/transactions")
                            }.bind(this)
                          }
                        ];

                    await this.updateUser();
                  } else if (s === 404) {   // No such user wallet -----------------------------------------------------
                    this.$refs.content.scrollTo(0, 0);
                    this.modal.className = "";
                    this.notification = {
                      show: true, className: "is-danger",
                      text: 'Sikupata pochi. Wallet not found.'
                    }
                  } else if (s <= 499) {   // Some other 'user' fault --------------------------------------------------
                    this.$refs.content.scrollTo(0, 0);
                    this.modal.className = "";
                    this.notification = {
                      show: true, className: "is-danger",
                      text: this.$t("Error") + ' ' + (response.data.message || 'Unknown cause')
                    }
                  } else {                 // server fault -------------------------------------------------------------
                    this.$refs.content.scrollTo(0, 0);
                    this.modal.className = "";
                    this.notification = {
                      show: true, className: "is-danger",
                      text: 'Onyesha hii kwa mhandisi. Show this to support: "WebApiV2.Controllers.TransactionsController.New-- Unexpected result code: ' + s + '"'
                    }
                  }
                }
            ).catch((error) => {
                  console.dir(error);
                  this.$refs.content.scrollTo(0, 0);
                  this.modal.className = "";
                  let message = this.$t("Error");
                  if (error.response && error.response.data) { message += " "+error.response.data.message}
                  else (message += " Unknown cause.")
                  this.notification = {
                    show: true, className: "is-danger",
                    text: message
                  }
                }
            );
            

        } catch(error) {
          console.dir(error);
          this.$refs.content.scrollTo(0, 0);
          this.modal.className = "";

          if (error.response && error.response.data) {
            this.notification =
                {
                  show: true,
                  className: "is-danger",
                  text: error.response.data.message
                }
          } else {
            this.notification =
                {
                  show: true,
                  className: "is-danger",
                  text: this.$t("Error")
                }
          }
        }
      }
  }
};
</script>
